import { connect } from 'react-redux'
import { notifyActions, vpnActions, paymentActions } from '../store/actions';
import pageVpn from './pages/pass';

const mapStateToProps = state => {
    return {
        ...state,
        vpn: state.vpn,
        role: state.role,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setNumberVpnPass: (data) => {
            dispatch(vpnActions.setNumberVpnPass(data))
        },
        addVpnPass: (data) => {
            dispatch(vpnActions.addVpnPass(data))
        },
        removeVpnPass: (id) => {
            dispatch(vpnActions.removeVpnPass(id))
        },
        editVpnPass: (data) => {
            dispatch(vpnActions.editVpnPass(data))
        },
        setIdPaymentForDetail: (data) => {
            dispatch(paymentActions.setIdPaymentForDetail(data))
        },
        setIdVpnPassForDetail: (data) => {
            dispatch(vpnActions.setIdVpnPassForDetail(data))
        },
        setKeyVpnPassForDetail: (data) => {
            dispatch(vpnActions.setKeyVpnPassForDetail(data))
        },
        successNotify: (message) => {
            dispatch(notifyActions.successAction(message))
        },
        warningNotify: (message) => {
            dispatch(notifyActions.warningAction(message))
        },
        errorNotify: (message) => {
            dispatch(notifyActions.errorAction(message))
        },
        infoNotify: (message) => {
            dispatch(notifyActions.infoAction(message))
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(pageVpn);